import { useDailyUserAccess } from '@/api/daily-user-access';
import { useUserAccount } from '@/api/user';
import { useCallback, useEffect, useRef } from 'react';

export function useDailyUserAccessHandler() {
  const { loadingDailyUserAccess, updateDailyUserAccess } =
    useDailyUserAccess();
  const { isAuthorized } = useUserAccount();
  const intervalRef = useRef<NodeJS.Timeout>();

  const handleUpdateDailyUserAccess = useCallback(() => {
    if (!isAuthorized || loadingDailyUserAccess) {
      return;
    }

    if (!intervalRef.current) {
      updateDailyUserAccess();
      intervalRef.current = setInterval(updateDailyUserAccess, 65000);
    }
  }, [updateDailyUserAccess, isAuthorized, loadingDailyUserAccess]);

  useEffect(() => {
    handleUpdateDailyUserAccess();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [handleUpdateDailyUserAccess]);
}
